import { createStore, applyMiddleware } from "redux";

// Logger with default options
import logger from "redux-logger";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";

import rootReducer from "../reducers/index";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

const persistConfig = {
  key: "root",
  storage: storageSession,
  //whitelist: ["auth", "enrolment", "onboarding", "registration", "goalsetting", "credit"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
let middlewares = [thunk];
if (process.env.REACT_APP_ENV !== "production") {
  middlewares.push(logger);
}
// Redux: Store
const store = createStore(persistedReducer, applyMiddleware(...middlewares));

// Middleware: Redux Persist Persister
let persistor = persistStore(store);

// Exports
export { store, persistor };